import { apiService } from '../services/api'
import { UiPreloader } from 'ui-preloader';
import animateText from '../components/animateText';
import { animate } from "../components/animateComponents";
import * as AOS from 'aos';
import 'aos/dist/aos.css'; 
import { checkTapit } from "../components/checkTapit";
const api = new apiService();

export const page = async () => {
    AOS.init();
    checkTapit()
    animate();

    const firstPosition = document.getElementById('firstPosition') as HTMLElement;
    const datesGame = document.getElementById('datesGame') as HTMLElement;
    const myPosition = document.getElementById('myPosition') as HTMLElement;
    const tableRanking = document.getElementById('tableRanking') as HTMLElement;

	async function getRanking(semana: any){
        let node = {};
    
        return new Promise(async (resolve: any) => {
            const request = await api.executeGet('/doble-malta/juega-y-gana/ranking/' + semana)
    
            resolve(request)
        })
    }

    async function ranking(semana: any, varDefault: boolean = true){
        getRanking(semana).then(function (data: any) {
            setFirstPosition(data);
            setMyPosition(data, semana);
            setRankingWeek(data, semana);
            if (varDefault){
                setDates(data, varDefault);
            }
            console.log(data)
        });
    }

    function setFirstPosition(data: any){
        let htmlFirstPosition = `<span class="position">0</span>
            <p class="name"><span></span></p>
            <span class="points">0000</span>`;

        if (data.ranking.length !== 0){
            let pointFirstPosition = data.ranking[0]['points'];
            let nameFirstPosition = `${data.ranking[0].first_name.split(' ')[0]} ${data.ranking[0].last_name.split(' ')[0]}`;
            htmlFirstPosition = `<span class="position">1</span>
                                <p class="name">${nameFirstPosition}<span></span></p>
                                <span class="points">${pointFirstPosition}</span>`;
        }

        firstPosition.innerHTML = htmlFirstPosition;
    }
    
    function setDates(data: any, varDefault: boolean){
        let classActive = (varDefault) ? 'active-content' : '';
        let htmlDates = `
        <div class="content date-item ${classActive}" data-week="1">
            <h3>${data.dateStartWeek1}</h3>
        </div>
        <div class="content date-item" data-week="2">
            <h3>${data.dateStartWeek2}</h3>
        </div>
        <div class="content date-item" data-week="3">
            <h3>${data.dateStartWeek3}</h3>
        </div>`;

        datesGame.innerHTML = htmlDates;

        executeRankingByDate();
    }
    
    function setMyPosition(data: any, semana: any){
        let name = `${data['user_name']} ${data['user_lastname']}`;

        // let html = `
        //     <span class="position">0</span>
        //     <p class="name">${name}</p>
        //     <span class="points">0000</span>
        // `;

        let html = "";
        if (data.myRankingWeek.length !== 0){
            let position = data.myRankingWeek['position'];
            let points = data.myRankingWeek['user']['points' + semana];
            
            html = `
            <span class="position">${position}</span>
            <p class="name">${name}</p>
            <span class="points">${points}</span>
            `;
            
            myPosition.style.display = "flex";
        } else {
            myPosition.style.display = "none";
        }
       
       myPosition.innerHTML = html;
    }
    
    function setRankingWeek(data: any, semana: any){
        let html = "";

        if (data.rankingweek.length !== 0){
            let rankingweek = data.rankingweek;

            for(let i = 0; i < rankingweek.length; i++){
                let posicion = String(i + 1);
                let name = `${rankingweek[i]['first_name']} ${rankingweek[i]['last_name']}`;
                let points = rankingweek[i]['points' + semana];

                html += `
                    <div class="table-row">
                        <span class="position">${posicion}</span>
                        <p class="name">${name}</p>
                        <span class="points">${points}</span>
                    </div>
                `;
            }
        }
       
        tableRanking.innerHTML = html;
    }

    async function executeRankingByDate() {
        const datesItems:NodeListOf<HTMLElement> = document.querySelectorAll(".date-item");
        datesItems.length > 0 && Array.from(datesItems).map((item) => {
            let semana = item.getAttribute("data-week");

            item.addEventListener("click", (e) => {
                Array.from(datesItems).map((i) => {
                    i.classList.remove("active-content");
                });
                item.classList.add("active-content");
                ranking(semana, false);
            });
        });
    };

    await ranking("1");

    new animateText("#titleRanking")
    new animateText("#rankingDescription1")
    new animateText("#rankingDescription2")

    // const uiPreloader = UiPreloader.init();
    // uiPreloader.render();
}